export const fiscalYearFrag = `
    id
    dateFrom
    dateTo
    accountingType
`;
